import subjectNo from '../../assets/img/info/no/subject.png'
import optionalNo from '../../assets/img/info/no/optional.png'
import frameNo from '../../assets/img/info/no/frame.png'

export const allTypes = {
  'subject': [
    {
      lang: 'da',
      name: 'Fag <span class="do-bagde-break">UV-tid</span>',
      value: 'subject',
      order: 1,
      desc: 'Tæller UV-tid. To samtidige brikker tæller halvt.'
    },
    {
      lang: 'en',
      name: 'Subject',
      value: 'subject',
      order: 1,
      desc: 'Counting hours for the class. Two simultaneous activities count as halves.'
    },
    {
      lang: 'nb',
      name: 'Fag',
      value: 'subject',
      order: 1,
      desc: '<div style="width: 400px"><p class="marg-1-bottom marg-05-top">Fag: Standard for undervisningstimer. Legges to eller flere fag i samme tidsrom fordeles tiden likt mellom fagene.</p><img style="width: 80%;" src="' + subjectNo + '" /><p style="font-style: italic;margin-top: 0.5rem;font-weight: normal">Eksempel: to 60 minutters undervisningstimer i Norsk og Matematikk i samme tidsrom i en klasse telles som 30 minutter norsk og 30 min matematikk.</p></div>'
    }
  ],
  'optional': [
    {
      lang: 'da',
      name: 'Valgfag/Hold <span class="do-bagde-break">UV-tid</span>',
      value: 'optional',
      order: 2,
      desc: 'Tæller UV-tid. Tæller 100%, uafhængigt af andre brikker i samme tidsrum i klassen.'
    },
    {
      lang: 'en',
      name: 'Optional grades/groups',
      value: 'optional',
      order: 2,
      desc: 'Fully counting and independent from other activities in the same time period.'
    },
    {
      lang: 'nb',
      name: 'Valgfag/gruppe',
      value: 'optional',
      order: 2,
      desc: '<div style="width: 400px"><p class="marg-1-bottom marg-05-top">Valgfag/gruppe: Undervisningstimer som ikke teller fra andre fag. Er særlig nyttig for valgfag og tilvalgsfag. </p><img style="width: 80%;" src="' + optionalNo + '" /><p style="font-style: italic;margin-top: 0.5rem;font-weight: normal">Eksempel: to 60 minutters undervisningstimer i Spansk og Fransk i samme tidsrom telles som 60 min Spansk og 60 min Fransk.</p></div>'
    }
  ],
  'supplemental': [
    {
      lang: 'da',
      name: 'UUV <span class="do-bagde-break">UV-tid</span>',
      value: 'supplemental',
      desc: 'Tæller UV-tid. Og selvstændigt på understøttende undervisning.',
      order: 6
    },
    {
      lang: 'en',
      name: 'UUV',
      value: 'supplemental',
      desc: 'Tæller selvstændigt på understøttende undervisning.',
      order: 6
    },
    {
      lang: 'nb',
      name: 'UUV',
      value: 'supplemental',
      desc: 'Tæller selvstændigt på understøttende undervisning.',
      order: 6
    }
  ],
  'frame': [
    {
      lang: 'da',
      name: 'Temavisning',
      value: 'frame',
      order: 3,
      desc: 'Tæller ikke noget selv, men fagbrikker i samme tidsrum tæller 100%. Temavisning kan bruges til at markere temaer og anderledes dage i skemaet. Brikken er synlig, mens fag-brikker, der ligger samtidig med tema-brikken skjules for elever/forældre. '
    },
    {
      lang: 'en',
      name: 'Theme',
      value: 'frame',
      order: 3,
      desc: 'Can be used for marking themes and special days in the class schedule. The themed activity is visible for the pupils and parents, while classes that are overlapping the themed activity will not be visible. Classes are fully counting, and the themed activity is not.'
    },
    {
      lang: 'nb',
      name: 'Temavisning',
      value: 'frame',
      order: 3,
      desc: '<div style="width: 400px"><p class="marg-1-bottom marg-05-top">Temavisning (ramme): Brukes til å markere temaer eller spesielle dager/fag i timeplanen. Timer lagt inn med denne fagtype er synlig for elever/foresatte, og kan med fordel legges i samme tidsrom som andre fag, og vil da skjule disse for elever/foresatte. Temavisning telles ikke som undervisningstimer, det gjør derimot fagene som er lagt i samme tidsrom.</p><img style="width: 80%;" src="' + frameNo + '" /><p style="font-style: italic;margin-top: 0.5rem;font-weight: normal">Eksempel: \'Idrettsdag’\' opprettes som Temavisning, og legges over fagene som normalt ligger i timeplanen. Lærere ser alle timene, mens elever/foresatte ser ‘Idrettsdag’ i timeplanen. Kan også brukes på samme måte for å markere tilvalgsfag eller valgfag for elever. Legger man en temavisning over for eksempel fire tilvalgsfag, vil dette gi en forenklet visning til elevene.</p></div>'
    }
  ],
  'break': [
    {
      lang: 'da',
      name: 'Pause <span class="do-bagde-break">UV-tid</span>',
      value: 'break',
      desc: 'Tæller UV-tid. Andre lektioner bør ikke overlappe med en pause.',
      order: 7
    },
    {lang: 'en', name: 'Break', value: 'break', desc: 'Subjects should not overlap with breaks.', order: 7},
    {lang: 'nb', name: 'Pause', value: 'break', desc: 'Andre timer bør ikke overlapper med en pause.', order: 7}
  ],
  'resource': [
    {
      lang: 'da',
      name: 'Ressource (skjult) <span class="do-bagde-break">UV-tid</span>',
      value: 'resource',
      order: 4,
      desc: 'Tæller UV-tid for underviseren. Tæller ikke ned fra andre fag samtidig i klassen. Vises ikke i elev- og forældre visning.'
    },
    {
      lang: 'en',
      name: 'Resource (hidden)',
      value: 'resource',
      order: 4,
      desc: 'Can be used to register teaching resources. Is not visible to students/parents.'
    },
    {
      lang: 'nb',
      name: 'Ressurs (skjult)',
      value: 'resource',
      order: 4,
      desc: '<p style="width: 300px">Ressurs: Brukes til å markere ekstra ressurser i timeplanen. Teller ikke fra andre fag, og er særlig nyttig til å legge inn at det er en ekstra assistent (ressurs) til stede i klassen, f.eks.i form av SNO eller Barneveileder. Undervisningsfaget i samme tidsrom telles 100%, samme med ressursen. Faget er ikke synlig for elever/foresatte.</p>'
    }
  ],
  'person_resource': [
    {
      lang: 'da',
      name: 'Ressource (skjult) <span class="do-bagde-break">UV-tid</span>',
      value: 'person_resource',
      order: 4,
      desc: 'Tæller UV-tid for underviseren. Tæller ikke ned fra andre fag samtidig i klassen. Vises ikke i elev- og forældre visning.'
    },
    {
      lang: 'en',
      name: 'Resource (hidden)',
      value: 'person_resource',
      order: 4,
      desc: 'Can be used to register teaching resources. Is not visible to students/parents.'
    },
    {
      lang: 'nb',
      name: 'Ressurs (skjult)',
      value: 'person_resource',
      order: 4,
      desc: '<p style="width: 300px">Ressurs: Brukes til å markere ekstra ressurser i timeplanen. Teller ikke fra andre fag, og er særlig nyttig til å legge inn at det er en ekstra assistent (ressurs) til stede i klassen, f.eks.i form av SNO eller Barneveileder. Undervisningsfaget i samme tidsrom telles 100%, samme med ressursen. Faget er ikke synlig for elever/foresatte.</p>'
    }
  ],
  'other_tasks': [
    {
      lang: 'da',
      name: 'Anden tid <span class="pill pill--grey hint--top-right hint--medium" aria-label="Udfases fra skoleåret 21/22 pga. den nye arbejdstidsaftale (A20)">udfases</span>',
      value: 'other_tasks',
      desc: 'Ikke undervisning',
      order: 13
    },
    {lang: 'en', name: 'Other tasks', value: 'other_tasks', desc: 'Not teaching', order: 13},
    {lang: 'nb', name: 'Annen tid', value: 'other_tasks', desc: 'Ikke undervisning', order: 13}
  ],
  'other_stuff': [
    {
      lang: 'da',
      name: 'Øvrig tid <span class="pill pill--grey hint--top-right hint--medium" aria-label="Udfases fra skoleåret 21/22 pga. den nye arbejdstidsaftale (A20)">udfases</span>',
      value: 'other_stuff',
      desc: 'Ikke undervisning, ikke elev-relateret.',
      order: 12
    },
    {
      lang: 'en',
      name: 'Additional tasks',
      value: 'other_stuff',
      desc: 'Not classes and teaching, non-pupil related.',
      order: 12
    },
    {
      lang: 'nb',
      name: 'Øvrig tid',
      value: 'other_stuff',
      desc: 'Ikke undervisning, ikke elevrelatert.',
      order: 12
    }
  ],
  'available': [
    {
      lang: 'da',
      name: 'Rådighedstime',
      value: 'available',
      desc: 'Brug til at vise, hvornår en underviser kan tage en vikartime',
      order: 11
    },
    {
      lang: 'nb',
      name: 'Rådighetstime',
      value: 'available',
      desc: ' Brukes til å vise når en underviser kan ta en vikartime',
      order: 11
    },
    {
      lang: 'en',
      name: 'On-Call',
      value: 'available',
      desc: 'The \'On-Call\' event indicates a timeslot when a teacher is available and ready to take over a course as a substitute. These events can be prioritized within the Substitute Management module, ensuring that available teachers can be quickly identified and assigned to cover classes as needed.',
      order: 11
    }
  ],
  'person_resource_visible': [
    {
      lang: 'da',
      name: 'Ressource (synlig) <span class="do-bagde-break">UV-tid</span>',
      value: 'person_resource_visible',
      order: 5,
      desc: 'Tæller UV-tid for underviseren. Tæller ikke ned fra andre fag samtidig i klassen. Vises i elev- og forældre visning.'
    },
    {
      lang: 'en',
      name: 'Resource (Visible)',
      value: 'person_resource_visible',
      order: 5,
      desc: 'Can be used to register teaching resources. Visible to students/parents.'
    },
    {
      lang: 'nb',
      name: 'Ressurs (Vises for elever)',
      value: 'person_resource_visible',
      order: 5,
      desc: '<p style="width: 400px">Ressurs (vises for elever): Brukes til å markere ekstra ressurser i timeplanen. Teller ikke fra andre fag, og er synlig for elever/foresatte. Som fagtypen Ressurs, er denne også nyttig til å vise at det er ekstra personale til stede, f.eks en Miljøveileder, som også skal være synlig for elever/foresatte i timeplanen.</p>'
    }
  ],
  'club': [
    {lang: 'da', name: 'SFO tid', value: 'club', desc: 'Pædagogisk tid i SFO, FFO, DUS eller lignende', order: 8},
    {lang: 'en', name: 'SFO time', value: 'club', desc: 'Pedagogical time', order: 8},
    {lang: 'nb', name: 'SFO tid', value: 'club', desc: 'Pedagogisk tid', order: 8}
  ],
  'additional_tasks': [
    {
      lang: 'da',
      name: 'Øvrige opgaver',
      value: 'additional_tasks',
      desc: 'Tæller som Øvrige Opgaver. Ikke undervisning',
      order: 9
    },
    {lang: 'en', name: 'Not teaching', value: 'additional_tasks', desc: 'Not teaching', order: 9},
    {lang: 'nb', name: 'Øvrige oppgaver', value: 'additional_tasks', desc: 'Tæller som øvrige opgaver.', order: 9}
  ],
  'preparation': [
    {
      lang: 'da',
      name: 'Forberedelse',
      value: 'preparation',
      desc: 'Kan bruges til individuel eller fælles forberedelse (f.eks. teammøder m.m)',
      order: 10
    },
    {
      lang: 'en',
      name: 'Preparation',
      value: 'preparation',
      desc: 'Can be used for individual or joint preparation',
      order: 10
    },
    {
      lang: 'nb',
      name: 'Forberedelse',
      value: 'preparation',
      desc: 'Kan brukes til individuell eller felles forberedelse',
      order: 10
    }
  ],
  'pool': [
    {
      lang: 'da',
      name: 'Lokalpulje',
      value: 'pool',
      desc: 'Kan bruges til f.eks. udvikling, forberedelse, overlevering, opgaver i tilknytning til afslutning',
      order: 11
    },
    {
      lang: 'nb',
      name: 'Planleggingsdager',
      value: 'pool',
      desc: '',
      order: 11
    }
  ],
  'activity': [
    {
      lang: 'da',
      name: 'Aktivitet <span style="text-transform: initial">(m. reduktion)</span> <span class="do-bagde-break">UV-tid</span>',
      value: 'activity',
      desc: 'Bruges til at oprette aktiviteter i klasser, der skal reducere timepuljer fra andre fag.',
      order: 11
    }
  ],
  'reservation': [
    {
      lang: 'da',
      name: 'Reservation',
      value: 'reservation',
      desc: 'Bruges til f.eks. lokalebooking. Tæller intet og kommer IKKE i vikardækningen. Blokerer blot et tidsrum i en kalender',
      order: 11
    },
    {
      lang: 'nb',
      name: 'Reservasjon',
      value: 'reservation',
      desc: 'Brukes til f.eks. rombestilling. Teller ingenting - men blokkerer bare et tidsrom i en kalender',
      order: 11
    },
    {
      lang: 'en',
      name: 'Reservation',
      value: 'reservation',
      desc: 'Used for e.g. room booking. Counts for nothing - but simply blocks a time slot in a calendar',
      order: 11
    }
  ]
}

export const kindergartenTypes = {
  'with_kids': [
    {lang: 'da', name: 'Tid med børn', value: 'with_kids', desc: 'Tid sammen med børnene', order: 11},
    {lang: 'en', name: 'Tid med børn', value: 'with_kids', desc: 'Tid sammen med børnene', order: 11},
    {lang: 'nb', name: 'Tid med børn', value: 'with_kids', desc: 'Tid sammen med børnene', order: 11}
  ],
  'without_kids': [
    {lang: 'da', name: 'Tid uden børn', value: 'without_kids', desc: 'Tid uden børnene', order: 12},
    {lang: 'en', name: 'Tid uden børn', value: 'without_kids', desc: 'Tid uden børnene', order: 12},
    {lang: 'nb', name: 'Tid uden børn', value: 'without_kids', desc: 'Tid uden børnene', order: 12}
  ]
}



// WEBPACK FOOTER //
// ./src/components/Subjects/subjectTypes.js